import warehouseApi from '@/api/warehouse';
import userApi from '@/api/user';

const SET_WAREHOUSES_DATA = 'SET_WAREHOUSES_DATA';
const SET_LOADING = 'SET_LOADING';
const ADD_NEW_WAREHOUSE = 'ADD_NEW_WAREHOUSE';
const EDIT_DATA_WAREHOUSE = 'EDIT_DATA_WAREHOUSE';
const DELETE_WAREHOUSE = 'DELETE_WAREHOUSE';
const SET_CONFIGURATION = 'SET_CONFIGURATION';

const state = {
	warehouses: [],
	isLoading: false,
	config: {
		enabled: false,
		shipping_type: 'nearest',
	},
};
const getters = {
	warehouses: state => state.warehouses,
	isLoading: state => state.isLoading,
	configuration: state => state.config,
};
const mutations = {
	/**
     * Assign data To warehouses
     *
     * @param {Object} state
     * @param {Array} state.warehouses
     * @param {Array} payload
     *
     */
	[SET_WAREHOUSES_DATA]: (state, payload) => {
		state.warehouses = payload;
	},

	/**
     *
     * @param {Object} state
     * @param {Boolean} isLoading
     */
	[SET_LOADING]: (state, isLoading) => {
		state.isLoading = isLoading;
	},

	/**
     * Add new Warehouses
     *
     * @param {Object} state
     * @param {Array} state.warehouses
     * @private {Array} warehouses
    */
	[ADD_NEW_WAREHOUSE]: (state, payload) => {
		const warehouses = state.warehouses;
		warehouses.unshift(payload);
		state.warehouses = warehouses;
	},
	/**
     * Update Data Warehouse
     *
     * @param {Object} state
     * @param {Object} payload
     * @param {String} payload.label
     * @private {Number} index
     * @private {Array} warehouse
     */
	[EDIT_DATA_WAREHOUSE]: (state, payload) => {
		const index = state.warehouses.findIndex(warehouse => warehouse._id === payload._id);
		const warehouses = state.warehouses;
		if (index !== -1) {
			warehouses[index].address = payload.address;
			warehouses[index].city = payload.city;
			warehouses[index].label = payload.label;
			warehouses[index].phone_primary = payload.phone_primary;
			warehouses[index].phone_secondary = payload.phone_secondary;
			warehouses[index].pic_name = payload.pic_name;
			warehouses[index].province = payload.province;
			warehouses[index].subdistrict = payload.subdistrict;
			warehouses[index].user_id = payload.user_id;
			warehouses[index].zip = payload.zip;
			warehouses[index]._id = payload._id;
		}
		state.warehouses = warehouses;
	},

	/**
     * Delete Data Warehouses
     *
     * @param {Object} State
     * @param {Object} payload
     * @param {String} payload._id
     * @private {Array} warehouses
     * @private {Index} index
     */
	[DELETE_WAREHOUSE]: (state, payload) => {
		const index = state.warehouses.findIndex(warehouse => warehouse._id === payload._id);
		const warehouses = state.warehouses;
		if (index !== -1) {
			warehouses.splice(index, 1);
		}
		state.warehouses = warehouses;
	},

	/**
     * Set Configuration
     *
     * @param {Object} state
     * @param {Object} payload
     * @param {Boolean} payload.enable
     * @param {String} payload.shipping_type
     */
	[SET_CONFIGURATION]: (state, payload) => {
		state.config = {
			enabled: payload[0].enabled,
			shipping_type: payload[0].shipping_type,
		};
	},

};
const actions = {
	/**
     * Get data warehouses
     *
     * @param {Function} commit
     * @param {Object} getters
     * @param {Boolean} getters.isLoading
     * @param {Object} payload
     *
     */
	getDataWarehouse: ({ commit, getters }, payload) => {
		if (!getters.isLoading) {
			commit(SET_LOADING, true);
			const callback = (responses) => {
				const warehouses = responses.data;
				commit(SET_WAREHOUSES_DATA, warehouses);
				commit(SET_LOADING, false);
			};
			const err = (e) => {
				commit(SET_LOADING, true);
				console.log(e);
			};
			warehouseApi.getWarehouses(payload, callback, err);
		}
	},

	/**
     * Create New Warehouse
     *
     * @param {Funtion} commit
     * @param {Object} payload
     *
     */
	storeNewWarehouse: ({ commit }, payload) => {
		commit(ADD_NEW_WAREHOUSE, payload);
	},
	/**
     * Update Warehouse
     *
     * @param {Funtion} commit
     * @param {Object} payload
     *
     */
	updateWarehouse: ({ commit }, payload) => {
		commit(EDIT_DATA_WAREHOUSE, payload);
	},
	/**
     * Delete warehouse
     *
     * @param {Function} commit
     * @param {Object} payload
     */
	deleteWarehouse: ({ commit }, payload) => {
		commit(DELETE_WAREHOUSE, payload);
	},

	/**
     * Setting User Configuration
     *
     * @param {Function} commit
     * @param {Object} payload
     */
	settingUserConfiguration: ({ commit }, payload) => {
		const callback = (responses) => {
			const setting = responses.data;
			commit(SET_CONFIGURATION, setting);
		};
		const err = (e) => {
			console.log(e);
		};

		userApi.setUserSetting(payload, callback, err);
	},

	/** */
	fetchSettingUserConfiguration: ({ commit }, payload) => {
		const callback = (responses) => {
			const warehouseSetting = responses.data.filter(item => item.key === 'warehouse').map(curr => curr.value);
			commit(SET_CONFIGURATION, warehouseSetting);
		};
		const err = (e) => {
			console.log(e);
		};
		userApi.getUserSetting(payload, callback, err);
	},
};
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
